import React, { Component } from 'react';
import Card from 'antd/es/card/Card';
import Text from 'antd/es/typography/Text';
import Title from 'antd/es/typography/Title';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';

class _MessagesUser extends Component<IRootStoreProps> {
  render() {
    return (
      <Card bordered={false} title="Сообщения" style={{ marginBottom: 8 }}>
        <Title level={5}>{'С Новым годом и Рождеством!'}</Title>
        <Text type="secondary">{'30.12.2024'}</Text>
      </Card>
    );
  }
}

export const MessagesUserPage: WithoutStore = withStore(observer(_MessagesUser));
